export default __webpack_public_path__ + "static/media/disconnect.d8d20cd3.png";